/**
 *
 * InfoControlPanel
 *
 */

// import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import LeafletControlPanel from 'components/LeafletControlPanel';
import * as colors from 'styles/colors';

const InfoControlPanel = styled(LeafletControlPanel)`
  & > .panel-heading.panel-heading {
    background-color: ${colors.white};
    border-color: ${colors.red100};
    &:last-child {
      border: none;
    }
    .close {
      margin-bottom: 10px;
    }
    a + a {
      margin-left: 10px;
    }
  }
  h2,
  h3 {
    margin: 5px 0;
  }
  h2 {
    font-weight: bold;
    font-size: 1.2em;
  }
  h3 {
    font-weight: bold;
    font-size: 1.1em;
  }
  .flex-description {
    display: flex;
    & > :first-child {
      flex-grow: 1;
    }
    & .dropdown {
      margin-left: 10px;
    }
  }
  overflow-wrap: break-word;
  span + svg {
    margin-left: 5px;
  }
  max-width: calc(100vw - 85px);
  @media (min-width: 360px) {
    min-width: 240px;
    max-width: calc(100vw - 95px);
  }
  @media (min-width: 480px) {
    min-width: 320px;
  }
  @media (min-width: 768px) {
    min-width: 400px;
  }
  @media print {
    button,
    .flex-description > a {
      display: none;
    }
  }
`;

export default InfoControlPanel;
